import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './Navbar/navbar';
import Home from './Home/Home';
import Picture from './Pictures/Pictures';
import About from './About/About';
import ManagePhotos from './ManagePhotos/ManagePhotos';
import CreatePhotos from './ManagePhotos/CreatePhotos';
import AdminLogin from './Authentication/AdminLogin';
import ProtectedRoute from './Authentication/ProtectedRoute';

import "./App.css";

export default function App() {
  return (
    <div className="app-wrapper">

      {/* <div className="header-container">
        <img
          src="https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779176167/logo_sandeepani_vidyalaya_tanjez.jpg"
          alt="Logo"
          className="logo"
        />
      </div> */}
      <Navbar />
      {/* <img src={"https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779176167/logo_sandeepani_vidyalaya_tanjez.jpg"} alt="Logo" className="logo" />

      <Navbar /> */}

      <div className="page-wrapper">
        <Routes>
          <Route path="/" element={<Navigate to="/whyus" replace />} />
          <Route path="/whyus" element={<Home />} />
          <Route path="/pictures" element={<Picture />} />
          <Route path="/about" element={<About />} />

          <Route path="/admin-login" element={<AdminLogin />} />

          <Route
            path="/ManagePhotos"
            element={
              <ProtectedRoute>
                <ManagePhotos />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ManagePhotos/CreatePhotos"
            element={
              <ProtectedRoute>
                <CreatePhotos />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>

    </div>
  );
}